import React, { useEffect, useState, useRef } from 'react'
import { selectAll } from 'd3'
import Title from '../Title/Title'
import { connect } from 'react-redux'
import Container from '../Main/Container'
import { drawTriState } from '../Charts/D3/drawTriState'
import { drawBivariatePlot } from '../Charts/D3/drawBivariatePlot'
import Concept from '../Concept/Concept'
import * as Plot from '@observablehq/plot'
// import initSqlJs from 'sql.js/dist/sql-wasm.js'
import './Neighbors.css'

import axios from "axios";
// // Required to let webpack 4 know it needs to copy the wasm file to our assets
// const SQLite = await initSqlJs({
//     locateFile: file => `https://sql.js.org/dist/${file}`
// })

const Neighbors = props => {
    const w = 650, h = 600
    const [ selection, setSelection ] = useState('hover-over')
    const [ k, setK ] = useState(10)
    const [ zip, setZip ] = useState(null)
    const { dispatch , pathsDispatch, knnDispatch } = props,
        { polygons } = pathsDispatch,
        { coordinates, locations } = knnDispatch,
        onClick = evt => { setSelection(evt.target?.innerText?.toLowerCase()) },
        onChange = evt => {
            evt.preventDefault()
            if (evt.target.value.trim() !== '' && !isNaN(evt.target.value)){
                setK(evt.target.value)
            }
        },
        onSubmit = evt => {
            evt.preventDefault()
            if (evt.target.value.length !== 5 || isNaN(evt.target.value)) { return }
            setZip(evt.target.value)
        }
    useEffect(() => {
        dispatch.paths.loadGeoPaths()
        dispatch.knn.loadPCAComponents({ w, h })
        dispatch.knn.loadUSPlaceNames()
    }, [])
    return (
        <div className='main-page'>
            <Title h1='KMeans Clustering to find Neighbors'></Title>
            <Concept onClick={ onClick } selection={ selection } style={{ gridColumn : '1/2' }}>
                {
                    ['hover-over', 'zipcode'].map(o =>  {
                        const [a, ...rest] = o
                        return <div className={ ['div-buttons', selection == o ? 'selected' : '' ].join(' ') }
                                    onClick={evt => onClick(evt) }
                        >
                            <button className={ ['buttons', selection == o ? 'selected' : '', 'button-loc'].join(' ') }>
                                {
                                    `${ a.toUpperCase() + rest .join('')}`
                                }
                            </button>
                        </div> })
                }
            </Concept>
            { selection === 'hover-over' && <form>
                <label>Enter number of neighbors:</label>
                <input type='text' id='k' name='k' onChange={ onChange }/>
            </form> }
            { selection === 'zipcode' && <form>
                <label>Enter zipcode:</label>
                <input type='text' id='zipcode' name='zipcode' onChange={ onSubmit }/>
            </form> }
            <Container
                id='tristate-map'
                data={ polygons }
                width={ 650 }
                height={ 760 }
                renderChart={ drawTriState }
            />
            <Container
                id='k-clusters'
                data={ ({ coordinates, locations, k, zip, tab: selection }) }
                width={ w }
                height={ h }
                renderChart={ drawBivariatePlot }
            />
            {/*<Table/>*/}
        </div>
    )

}

const Table = () => {
    const [db, setDb] = useState(null)
    const [error, setError] = useState(null)
    useEffect(async () => {
        try {
            const SQL = await initSqlJs({ locateFile: () => SQLite })
            const dataPromise = fetch("./assets/census.db").then(res => res.arrayBuffer())
            const buf = await dataPromise
            setDb(new SQL.Database(new Uint8Array(buf)))
        } catch (err) {
            setError(err)
        }
    }, [])

    if (error) return <pre>{error.toString()}</pre>
    else if (!db) return <pre>Loading...</pre>
    else return <SQLRepl db={db} />

}
/**
 * A simple SQL read-eval-print-loop
 * @param {{db: import("sql.js").Database}} props
 */
const SQLRepl = ({ db }) => {
    const [error, setError] = useState(null)
    const [results, setResults] = useState([])

    function exec(sql) {
        try {
            let a = []
            let b
            let statement
            selectAll('.point.selection').each(d => a.push(d[2]))
            console.log(a)
            statement = `select id, cluster, per_latin_hisp, perc_black, educ_attain_25_over, median_age, per_inc_below_pov_line, est_owner_units_over_mill, median_household_inc, pop_2010, log10(cast(pop_2010 as int)) from zipcodes where cluster in ('9') and state in ('34','36','9') order by cast(pop_2010 as int) desc`
            // statement = `select id, cluster, per_latin_hisp, perc_black, educ_attain_25_over, median_age, per_inc_below_pov_line, est_owner_units_over_mill, median_household_inc, pop_2010, log10(cast(pop_2010 as int)) from zipcodes where id in ('${ a.join("','")}') order by cluster desc`
            // statement = `select id, cluster, per_latin_hisp, perc_black, educ_attain_25_over, median_age, per_inc_below_pov_line, est_owner_units_over_mill, median_household_inc, pop_2010, log10(cast(pop_2010 as int)) from zipcodes where cluster in ('4','8','9') and state in ('9') order by cast(pop_2010 as int) desc`
            // statement = `select median_household_inc from zipcodes where cluster in ('3') and state in ('34','36','9')`
            // The sql is executed synchronously on the UI thread.
            // You may want to use a web worker here instead
            setResults(db.exec(statement)) // an array of objects is returned
            setError(null)
        } catch (err) {
            // exec throws an error when the SQL statement is invalid
            setError(err)
            setResults([])
        }
    }

    return (
        <div className='plot' style={{ gridRow: '10 / 11', gridColumn: '1 / 3' }}>
            <h1>React SQL interpreter</h1>

            <button onClick={e => exec()} class="button button1">Click</button>

            <pre className="error">{(error || "").toString()}</pre>

            <pre>
                {
                    results.map(({ columns, values }) => {
                        let pop = columns.indexOf('pop_2010')
                        let d = values.reduce((a,b) => {
                            let c = a + parseInt(b[pop])
                            return c
                        }, 0)
                        return <p>{ d }</p>
                    })
                }
        {
            // results contains one object per select statement in the query
            // results.map(({ columns, values }, i) => (
            //     <ResultsTable key={i} columns={columns} values={values} />
            // ))
            results.map(({ columns, values }, i) => (
                <Ticks key={i} columns={columns} values={values} />
            ))
        }
      </pre>
        </div>
    )
}
/**
 * Renders a single value of the array returned by db.exec(...) as a table
 * @param {import("sql.js").QueryExecResult} props
 */
const ResultsTable = ({ columns, values }) => {
    console.log(values.map(o => +o[0]))
    return (
        <table>
            <thead>
            <tr>
                {columns.map((columnName, i) => (
                    <td key={i}>{columnName}</td>
                ))}
            </tr>
            </thead>

            <tbody>
            {
                // values is an array of arrays representing the results of the query
                values.map((row, i) => (
                    <tr key={i}>
                        {row.map((value, i) => (
                            <td key={i}>{value}</td>
                        ))}
                    </tr>
                ))
            }
            </tbody>
        </table>
    )
}

const Ticks = ({ columns, values }) => {
    const containerRef = useRef()
    useEffect(() => {
        function transposeMatrixMapReduce(matrix) {
            return matrix[0].map((col, c) => matrix.map((row, r) => parseFloat(matrix[r][c])));
        }
        const matrix = transposeMatrixMapReduce(values)
        const arr = [
            {col: 2, domain:[0,100]},
            {col: 3, domain:[0,100]},
            {col: 4, domain:[0,100]},
            {col: 5, domain:[0,100]},
            {col:6, domain:[0,100]},
            {col:7, domain:[8, 100]},
            {col: 8, domain: [10, 100]},
            {col: 10, domain:[0,5]}
        ]
        // const arr = [2,3,4,5,6,7,8]
        for (let i = 0; i < arr.length; i++) {
            // const plot = Plot.plot({
            //     x: {
            //         grid: true,
            //         inset: 6
            //     },
            //     marks: [
            //         Plot.boxX(matrix, {x: matrix[arr[i].col], y: columns[arr[i].col]})
            //     ]
            // })
            const plot = Plot.plot({
                x: {
                    grid: true,
                    // label: "Population (%)",
                    label: [columns[arr[i].col]],
                    percent: false
                },
                y: {
                    // domain: [columns[arr[i].col]], // in age orderx
                    // reverse: true,
                    // label: [columns[arr[i].col]],
                    // labelAnchor: "top"
                },
                marks: [
                    Plot.ruleX(matrix[arr[i].col], {stroke: matrix[1], strokeOpacity: Math.log10(matrix[9]) * .2}),
                    Plot.tickX(matrix, { x: arr[i].domain})
                ],
                color: {
                    type: "categorical", // Specify the type as categorical
                    domain: [1, 2, 3, 4, 5, 6, 7, 8, 9], // Specify the domain (the unique values in your categorical field)
                    range: ['#89cfa5','#FED281','#5e50a2','#FBF8B0','#f88e53','#4696b3','#9f0142','#db494a','#d5ee9f']
                    // legend: true // Add a legend for the colors
                },
            //     const plot = Plot.plot({
            //         x: {percent: true, ticks: 10},
            //         color:  { type: "categorical", // Specify the type as categorical
            //             domain: ["1", "2", "3", "4", "5", "6", "7", "8", "9"], // Specify the domain (the unique values in your categorical
            //             range: ['#89cfa5','#f88e53','#FBF8B0','#FED281','#5e50a2','#4696b3','#9f0142','#db494a','#d5ee9f']
            //         }
            //         ,
            //         marks: [
            //             Plot.barX(transformed, {x1: "min", x2: "max", fillOpacity: 0.75, inset: 0.5, fill: 'cluster', stroke: 'black'}),
            //             Plot.textX(transformed, {x: "mid", text: "cluster", inset: 0.5}),
            //             Plot.ruleX([.25, 1.4]),
            //
            //         ]
            //     })
            })
            containerRef.current.append(plot)
            // return () => plot.remove()
        }
    },[values])

    return <div ref={containerRef} />
}

const mapStateToProps = () => (
    dispatch => ({
        pathsDispatch: dispatch.paths,
        knnDispatch: dispatch.knn
    })
)

export default connect(mapStateToProps)(Neighbors)
